import { cn } from '@quadralize/utils'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { RecordCircle } from '@solar-icons/react'
import * as React from 'react'
import { LabelWrapper } from '../label/label'

const RadioGroup = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
    label?: string
    required?: boolean
    error?: boolean
    helperText?: React.ReactNode
  }
>(({ className, label, id, required, error, helperText, ...props }, ref) => {
  const generatedId = React.useId()
  const groupId = id || generatedId

  return (
    <LabelWrapper
      label={label}
      id={groupId}
      required={required}
      error={error}
      helperText={helperText}
      className="flex flex-col gap-3"
    >
      <RadioGroupPrimitive.Root
        id={groupId}
        className={cn('grid gap-2', className)}
        {...props}
        ref={ref}
      />
    </LabelWrapper>
  )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'aspect-square h-4 w-4 rounded-full border border-primary text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-focus-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <RecordCircle className="h-3.5 w-3.5 fill-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
